import { NextPage } from "next";
import Head from "next/head";
import styled, { css } from "styled-components";
import { TextBlockWithTitle } from "../components/TextBlockWithTitle";
import { PageLayout, PageTypes } from "../layouts/page";
import { xSmallScreen } from "../lib/mediaQuery";

const TermsOfService: NextPage = () => {
  return (
    <>
      <Head>
        <title>Terms of Service</title>
      </Head>
      <PageLayout showAccents pageType={PageTypes.NARROW}>
        <TextBlockWithTitle title={"Terms of Service"}>
          <Text>
            Terms of Service IMPORTANT NOTICE: THIS AGREEMENT IS SUBJECT TO
            BINDING ARBITRATION AND A WAIVER OF CLASS ACTION RIGHTS AS DETAILED
            IN THE SECTION ENTITLED DISPUTE RESOLUTION.
            <br />
            Please note: Apple Inc. are in no way linked or associated with the
            VAULT app.
            <br />
            <br />
            Effective: November 16th, 2023
            <br />
            <br />
            These Terms of Service (“Terms”) are a contract between you and
            VAULT Laboratories Inc. They govern your use of the VAULT
            Laboratories application (the “App”) and any associated or
            connected, and other services, features, content, or applications we
            offer through the App (collectively, the “Services”). By using
            VAULT, you agree to these Terms. If you don’t agree to any of the
            Terms, you can’t use VAULT.
            <br />‍<br />
            Except for the Section entitled Dispute Resolution, providing for
            binding arbitration and waiver of class action rights, VAULT
            reserves the right, at its sole discretion, to modify or replace the
            Terms of Use at any time. The most current version of these Terms
            will be shared on our Site. You shall be responsible for reviewing
            and becoming familiar with any such modifications. If a revision to
            the Terms, in our sole discretion, is material, we will notify you
            of that revision by contacting you through the email address
            associated with your account. Use of the Services by you after any
            modification to the Terms constitutes your acceptance of the Terms
            of Use as modified.
            <br />
            <br />
            Risks
            <br />
            Before using VAULT’s services, creating a Solana wallet, or
            purchasing Solana to unlock features or content provided through
            VAULT,  you must consider whether using those Services is suitable
            for you in light of your financial circumstances.  The value of
            digital assets like cryptocurrency fluctuates, and may become
            worthless.  Cryptocurrency is not legal tender.  The past value or
            performance of a digital asset is not an indicator of its future
            value or performance.  You agree that VAULT is not responsible for
            any loss of a digital asset, or any losses arising from theft, loss,
            or mishandling of any digital asset, including but not limited to
            Solana, outside of VAULT’s sole control.  There is no assurance that
            a person that accepts cryptocurrency as payment today will continue
            to do so in the future.
            <br />‍<br />
            Additionally, cryptocurrencies are not insured by the Federal
            Deposit Insurance Corporation (FDIC), the Securities Investor
            Protection Corporation (SIPC) or any other public or private
            insurer, including against cyber theft or theft by any other means. 
            The nature of cryptocurrency may lead to an increased risk of fraud
            or cyber-attack and your cryptocurrency value may be irretrievably
            lost or stolen.  Transfers or transactions in cryptocurrency is
            irrevocable an irreversible.  Cryptocurrency assets are not
            regulated in many states.  
            <br />‍<br />
            VAULT is not an investment service and does not provide investment
            advice.  No information on the site, including but not limited to
            information provided by VAULT, should be considered a substitute for
            professional investment advice.  You agree that you may not use the
            contents of VAULT’s site or services or User Content (defined below)
            to make investment decisions.
            <br />
            VAULT is not a digital asset market and does not make any
            representations or warranties as to the value (real or perceived) of
            digital assets of any type, including but not limited to Solana. 
            VAULT may provide information regarding the price of digital assets,
            it does not make any representations or warranties regarding the
            truth, usefulness, suitability, quality, accuracy, or completeness
            of that data, and you should not rely on such pricing data provided
            by VAULT for any reason.  You must independently verify any such
            information from a reputable source before relying on pricing
            information.  Digital asset values are often volatile and may change
            instantaneously.  VAULT is not responsible or liable for any losses
            incurred by using or transferring digital assets in connection with
            or based on information you have received through our Services.
            <br />
            Subscriptions If you provide premium content to your VAULT, you are
            a Creator.  If you are a Key holder using VAULT to access premium
            content provided by Creators, you are a Viewer.  
            <br />‍<br />
            Creators may offer content to Viewers that have purchased a
            specified Key.  The amounts required to purchase a Key are entirely
            at the Creator’s discretion.  Creators may change the required
            amount of Solana required to access content at any time through
            their VAULT accounts.  
            <br />‍<br />
            If a Viewer has a dispute with a Creator, you agree that VAULT has
            no obligations to either party other than direct inquiries regarding
            a Creator’s premium content to the appropriate Creator. VAULT shall
            have no liability or responsibility to provide premium content on a
            Creator’s behalf or in any way fulfill the terms of a Creator’s
            agreement with their Viewers.
            <br />
            Content Rights & Responsibilities You own the rights to the content
            you create and share on and through VAULT (“User Content”). You
            acknowledge and agree that all User Content that you share on or
            through VAULT is your sole responsibility. You represent that you
            have all required rights to Post or transmit such User Content
            without violation of any third-party rights. By sharing content you
            didn’t create to VAULT, you are representing that you have the right
            to do so. For example, you are sharing a work that’s in the public
            domain, used under license (including a free license, such as
            Creative Commons), or a fair use.
            <br />‍<br />
            This means you assume all risks related to it, including someone
            else’s reliance on its accuracy, or claims relating to intellectual
            property or other legal rights. You agree that you will indemnify,
            defend, and hold harmless VAULT for all claims resulting from User
            Content you Post or Share through VAULT. We reserve the right, at
            our own expense, to assume the exclusive defense and control of such
            disputes, and in any event, you will cooperate with us in asserting
            any available defenses.
            <br />‍<br />
            To protect information from accidental or malicious destruction, we
            may not immediately delete residual copies from our active servers
            and may not remove information from our backup systems. As a user of
            VAULT you recognise and agree that you are solely responsible for
            your User Content and the consequences of sharing it or otherwise
            making it available on the Service. As a user of VAULT you agree not
            to post content that some viewers may deem inappropriate such as:
            Information that contains obscene expressions or nude images;
            Information that is fraudulent, false or self-deceiving or that
            leads to misunderstanding; Information that furthers discrimination,
            prejudice, racial discrimination, hatred, harassment or infringement
            of individuals or associations; Information that is violent or
            intimidating, or that furthers violence or intimidating act to
            others; Information that infringes the patent right, model utility
            right, design right, trademark right, copyright, portrait right or
            any other right; Information that violates laws and regulations or
            furthers violating act; Any other information that is deemed
            inappropriate by the Company.
            <br />
            <br />
            As a user of VAULT you understand and agree that you may be exposed
            to User Content that is inaccurate, objectionable, inappropriate for
            children, or otherwise unsuited to your purpose, and you agree that
            Company shall not be liable for any damages you allege to incur as a
            result of or relating to any User Content. If you see any content on
            VAULT that you deem offensive or inappropriate please use the
            Feedback button on the live streaming page and send us an email
            outlining the inappropriate content or conduct that breachers our
            terms of service.
            <br />
            <br />
            Our Content and Services We reserve all rights in the Service. Some
            parts of VAULT are licensed under third-party open source licenses.
            As for other parts of VAULT, you may not copy or adapt any portion
            of our code or visual design elements (including logos) without
            express written permission from VAULT unless otherwise permitted by
            law. You may not do, or try to do, the following: (1) access or
            tamper with non-public areas of the Services, our computer systems,
            or the systems of our technical providers; (2) access or search the
            Services by any means other than the currently available, published
            interfaces (e.g., APIs) that we provide; (3) forge any TCP/IP packet
            header or any part of the header information in any email or
            sharing, or in any way use the Services to send altered, deceptive,
            or false source-identifying information; or (4) interfere with, or
            disrupt, the access of any user, host, or network, including sending
            a virus, overloading, flooding, spamming, mail-bombing the Services,
            or by scripting the creation of content or accounts in such a manner
            as to interfere with or create an undue burden on the Services.
            Crawling the Services is allowed if done in accordance with the
            provisions of our robots.txt file, but scraping the Services is
            prohibited. We may change, terminate, or restrict access to any
            aspect of the service, at any time, without notice.
            <br />
            <br />
            Dispute Resolution PLEASE READ THIS SECTION CAREFULLY – IT MAY
            SIGNIFICANTLY AFFECT YOUR LEGAL RIGHTS, INCLUDING YOUR RIGHT TO FILE
            A LAWSUIT IN COURT.
            <br />
            <br />
            Our Customer Support Department is available by email,
            support@vault.fan, in app, or via the web to address any concerns
            you may have regarding the Service. Our Customer Service Department
            is able to resolve most concerns quickly to our players’
            satisfaction. The parties shall use their best efforts through this
            Customer Service process to settle any dispute, claim, question, or
            disagreement and engage in good faith negotiations which shall be a
            condition to either party initiating a lawsuit or arbitration. If
            the parties do not reach an agreed upon solution within a period of
            30 days from the time informal dispute resolution under the Initial
            Dispute Resolution provision, then either party may initiate binding
            arbitration as the sole means to resolve claims, subject to the
            terms set forth below. Specifically, all claims arising out of or
            relating to these Terms (including their formation, performance and
            breach), the parties’ relationship with each other and/or your use
            of the Service shall be finally settled by binding arbitration
            administered by National Arbitration and Mediation (“NAM”) in
            accordance with the provisions of its Arbitration Rules and the
            supplementary procedures for consumer related disputes, excluding
            any rules or procedures governing or permitting class actions.
            <br />‍<br />
            The arbitrator, and not any federal, state or local court or agency,
            shall have exclusive authority to resolve all disputes arising out
            of or relating to the interpretation, applicability, enforceability
            or formation of these Terms, including, but not limited to any claim
            that all or any part of these Terms are void or voidable, or whether
            a claim is subject to arbitration. The arbitrator shall be empowered
            to grant whatever relief would be available in a court under law or
            in equity. The arbitrator’s award shall be written, and binding on
            the parties and may be entered as a judgment in any court of
            competent jurisdiction. The Commercial Arbitration Rules governing
            the arbitration may be accessed at www.namadr.com or by calling NAM
            at +1.800.358.2550. Any arbitration demand or counterclaim asserted
            by either party must contain sufficient information to provide fair
            notice to the other party of the asserting party’s identity, the
            claims being asserted, and the factual allegations on which they are
            based, including proof that you are a VAULT customer. The arbitrator
            and/or NAM may require amendment of any demand or counterclaim that
            does not satisfy these requirements. The arbitrator has the right to
            impose sanctions in accordance with NAM rules for any claims the
            arbitrator determines to be frivolous or improper (under the
            standard set forth in Federal Rule of Civil Procedure 11). The
            parties agree that NAM has discretion to modify the amount or timing
            of any administrative or arbitration fees due under NAM’s Rules
            where it deems appropriate, including in mass filing cases by
            batching or consolidating cases where deemed appropriate by the
            procedural arbitrator, provided that such modification does not
            increase the costs to you, and you waive any objection to such fee
            modification. The parties also agree that a good-faith challenge by
            either party to the fees imposed by NAM does not constitute a
            default, waiver, or breach of this section while such challenge
            remains pending before NAM, the arbitrator, and/or a court of
            competent jurisdiction.
            <br />
            To the extent the filing fee for the arbitration exceeds the cost of
            filing a lawsuit, the arbitrator may require VAULT to pay the
            additional cost. The arbitration rules also permit you to recover
            attorney’s fees in certain cases. The parties understand that,
            absent this mandatory provision, they would have the right to sue in
            court and have a jury trial. They further understand that, in some
            instances, the costs of arbitration could exceed the costs of
            litigation and the right to discovery may be more limited in
            arbitration than in court. If you are a resident of the United
            States, arbitration will take place at any reasonable location
            within the United States convenient for you. For residents in
            Canada, arbitration shall be initiated in the County of New York,
            State of New York, United States of America, and you and VAULT agree
            to submit to the personal jurisdiction of any federal or state court
            in New York County, New York, in order to compel arbitration, to
            stay proceedings pending arbitration, or to confirm, modify, vacate
            or enter judgment on the award entered by the arbitrator. The
            parties further agree that any arbitration shall not be conducted as
            a class action or other representative action, and the parties
            expressly waive their right to file a class action or seek relief on
            a class basis.
            <br />
            YOU AND VAULT AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER
            ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR
            CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING.
            <br />‍<br />
            If any court or arbitrator determines that the class action waiver
            set forth in this paragraph is void or unenforceable for any reason
            or that an arbitration can proceed on a class basis, then the
            arbitration provision set forth above shall be deemed null and void
            in its entirety and the parties shall be deemed to have not agreed
            to arbitrate disputes. Notwithstanding the parties' decision to
            resolve all disputes through arbitration, either party may bring an
            action in state or federal court to protect its intellectual
            property rights (“intellectual property rights” means patents,
            copyrights, moral rights, trademarks, and trade secrets, but not
            privacy or publicity rights). Either party may also seek relief in a
            small claims court for disputes or claims within the scope of that
            court’s jurisdiction, regardless of where it is first filed. You
            have the right to opt-out and not be bound by the arbitration and
            class action waiver provisions set forth above by sending written
            notice of your decision to opt-out to the following address: VAULT,
            Laboratories Inc. 100 Mamaroneck Avenue, Mamaroneck, New York 10543.
            The notice must be sent within 30 days your first use of the
            Service, otherwise you shall be bound to arbitrate disputes in
            accordance with the terms of those paragraphs. If you opt-out of
            these arbitration provisions, VAULT also will not be bound by them,
            and all disputes will revert to court. VAULT will provide 60-days’
            notice of any changes to this section. Changes will become effective
            on the 60th day, and will apply prospectively only to any claims
            arising after the 60th day. For any dispute not subject to
            arbitration you and VAULT agree to submit to the personal and
            exclusive jurisdiction of and venue in the federal and state courts
            located in New York, NY. You further agree to accept service of
            process by mail, and hereby waive any and all jurisdictional and
            venue defenses otherwise available. The Terms and the relationship
            between you and VAULT shall be governed by the laws of the State of
            New York without regard to conflict of law provisions.
            <br />‍<br />
            No Children VAULT is only for people 18 years old and over. By using
            VAULT, you affirm that you are over 18. If we learn someone under 18
            is using VAULT, we’ll terminate their account.
            <br />
            <br />
            Security If you find a security vulnerability on VAULT, please email
            support@vault.fan.
            <br />
            <br />
            Incorporated Rules and Policies By using the Services, you agree to
            let VAULT collect and use information as detailed in our{" "}
            <a href="/privacy-policy">Privacy Policy</a>. If you’re outside the
            United States, you consent to letting VAULT transfer, store, and
            process your information (including your personal information and
            content) in and out of the United States. For copyright complaints,
            please see our <a href="/copyright-notice">DMCA Policy</a>. By using
            VAULT, you agree to follow these Rules and Policies. If you don’t,
            we may remove content, or suspend or delete your account.
            <br />
            <br />
            Miscellaneous
            <br />
            <br />
            Disclaimer of Warranty VAULT provides the Services to you as is. You
            use them at your own risk and discretion. That means they don’t come
            with any warranty. None express, none implied. No implied warranty
            of merchantability, fitness for a particular purpose, availability,
            security, title or non-infringement.
            <br />‍<br />
            Limitation of Liability VAULT won’t be liable to you for any damages
            that arise from your using the Services or any connected or
            associated services. This includes if the Services or any connected
            or associated services are hacked or unavailable. This includes all
            types of damages (indirect, incidental, consequential, special or
            exemplary). And it includes all kinds of legal claims, such as
            breach of contract, breach of warranty, tort, or any other loss.
            <br />
            No Waiver If VAULT doesn’t exercise a particular right under these
            Terms, that doesn’t waive it.
            <br />
            <br />
            Severability If any provision of these terms is found invalid by a
            court of competent jurisdiction, you agree that the court should try
            to give effect to the parties’ intentions as reflected in the
            provision and that other provisions of the Terms will remain in full
            effect.
            <br />‍<br />
            Choice of Law and Jurisdiction These Terms are governed by New York
            law, without reference to its conflict of laws provisions. Subject
            to the dispute resolution clause above, you agree that any suit
            arising from the Services must take place in a court located in New
            York, New York.
            <br />‍<br />
            Entire Agreement These Terms (including any document incorporated by
            reference into them) are the whole agreement between VAULT and you
            concerning the Services. If you have any questions please email
            support@vault.fan.
            <br />
            Taxes You are responsible for any applicable national, state, local,
            sales, or use taxes, value added taxes, or similar taxes or fees
            payable in connection with your use or redemption of Pixels.  If you
            do not pay such taxes, you will be responsible for the tax liability
            if the transaction is later determined to be taxable, and VAULT
            reserves the right to collect taxes or other fees from you at any
            time.
            <br />‍<br />
            Any violations or attempted violations of this Policy or VAULTs’
            terms, by you (or any third party acting on your behalf) are a
            material breach, and may subject your account to termination.
            Violations of this policy or VAULT’s terms  may result in civil or
            criminal liability, and VAULT, in its sole discretion, in addition
            to any remedy that it may have at law or in equity, may immediately
            terminate permission for you to use Pixels. VAULT may bring legal
            action to enjoin violations and/or collect damages caused by any
            violation of its policies or terms.
            <br />‍<br />
            VAULT’s decision not to enforce this AUP in every instance in which
            it might have application does not amount to a waiver of VAULT’s
            rights.
          </Text>
        </TextBlockWithTitle>
        <TextBlockWithTitle title="Fantasy Record Label Terms of Service">
          <Text>
            Effective: November 16th, 2023
            <br />
            <br />
            IMPORTANT NOTICE: THIS AGREEMENT IS SUBJECT TO BINDING ARBITRATION
            AND A WAIVER OF CLASS ACTION RIGHTS AS DETAILED IN VAULT’S TERMS OF
            SERVICE.
            <br />
            <br />
            These Fantasy Record Label Terms of Service (“Terms”) are a legal
            contract between you (the “user”) and VAULT Laboratories Inc.
            (“VAULT”, “we”, “us”). The Terms govern your access to and use of
            the VAULT Fantasy Record Label and any associated or connected, and
            other services, applications, features, content, or applications we
            offer (collectively, the “Services”). By using the Service, you
            agree to these Terms, VAULT’s Terms of Service
            (https://vault.fan/terms-of-service), and VAULT’s Privacy Policy
            (https://vault.fan/privacy-policy). If you don’t agree to these
            Terms, VAULT’s Terms of Service, and VAULT’s Privacy Policy, you
            can’t use the Service.
            <br />
            <ol>
              <li>
                Eligibility
                <br /> You hereby represent and warrant that you are fully able
                and competent to enter into the terms, conditions, obligations,
                affirmations, representations and warranties set forth in these
                Terms and to abide by and comply with these Terms. Access to and
                use of the Service is available only to individuals who are at
                least 18 years old and can form legally binding contracts under
                applicable law. By accessing or using the Service, you represent
                and warrant that you are eligible.
                <br />
                By entering a contest, you are representing and warranting that:
                <br />
                • you are a natural person of at least 18 years of age or the
                age of majority in your jurisdiction, whichever is higher, who
                is personally assigned to the email address and/or other
                information submitted in relation to your account;
                <br />
                • you are a citizen or resident of (and have an address in) the
                United States of America, or another jurisdiction in which
                participation in the contest is not prohibited by applicable
                law;
                <br />
                • at the time of participation in a contest, you are physically
                located in the United States of America or another jurisdiction
                in which participation in the contest is not prohibited by
                applicable law;
                <br />
                • you will abide at all times by these Terms and any Other
                Governing Agreement between you and VAULT regarding your use of
                the Service or participation in contests;
                <br />
                • when entering a paid contest for which you have to own certain
                NFTs, you are not physically located in of any of the following
                states: Arizona, Iowa and Louisiana
                <br />
                • you are not subject to backup withholding tax because: (a) you
                are exempt from backup withholding, or (b) you have not been
                notified by the Internal Revenue Service (IRS) that you are
                subject to backup withholding as a result of a failure to report
                all interest or dividends, or (c) the IRS has notified you that
                you are no longer subject to backup withholding;
                <br />
                • when entering any contest that awards prizes, you are not an
                employee of or contributor for a musical artist, record label,
                music streaming service (such as Spotify) or production company
                associated with the musical artist associated with that contest.
                <br />
                If you do not meet the eligibility requirements of this section,
                then you are not permitted to use the Service and you agree that
                you will not use the Service. In addition to any other rights
                that VAULT may have in law or equity, VAULT reserves the right
                to suspend or terminate the account of any purported user of the
                Service that, in our sole discretion, does not meet the
                foregoing requirements. In such a situation, VAULT may pay out
                any withheld or revoked prizes to the other entrant(s) in the
                relevant contest in a manner consistent with the prize structure
                of the contest, to be precisely determined by VAULT in its sole
                discretion. <br />
                VAULT employees may use the Service for the purpose of testing
                the user experience, but may not enter paid contests unless they
                are private contests with other VAULT employees. Relatives of
                VAULT employees with whom they share a household are not
                eligible to participate in paid contests unless they are private
                contests with other VAULT employees or household members.
                <br />
                VAULT consultants or promoters of the Service may play in
                contests without such limitation, but only if (i) their
                arrangement with VAULT does not permit them to have any access
                to the source code underlying the VAULT Services and (ii) they
                do not receive any other advantages in their play on the
                Service.
                <br />
              </li>
              <li>
                Conditions of Participation
                <br />
                In order to use the Service, including participation in a
                contest on the Service, you are required to register for an
                account. By registering for an account, you agree to: (i)
                maintain the security and confidentiality of your registration
                data; (ii) ensure that others do not use your account; and (iii)
                notify VAULT immediately in the event of unauthorized use of, or
                any other breach of your registration data.
                <br />
                You agree that VAULT is not liable for any loss or damage
                resulting from your failure to maintain the confidentiality of
                your account as provided herein. VAULT may assume that any
                communications VAULT receives under your password have been made
                by you. You are fully responsible for all uses of your account,
                whether by you or others. You acknowledge and agree that VAULT
                is authorized to act on instructions received through use of
                your registration data, and that VAULT may, but is not obligated
                to, deny access or block any transaction made through use of
                your registration data without prior notice if we believe in our
                sole discretion such information is being used by someone other
                than you, or for any other reason. You agree that VAULT may deny
                you access to the Service or terminate your account at its sole
                discretion. <br />
                You may establish, maintain, use and control only one account on
                the Service. Each account on the Service may only be owned,
                maintained, used and controlled by only one individual. For
                avoidance of doubt, users may not “co-own” accounts on the
                Service. In the event VAULT determines that you have opened,
                maintained, used or controlled more than one account, in
                addition to any other rights that VAULT may have, VAULT reserves
                the right to suspend or terminate any or all of your accounts
                and terminate, withhold or revoke the awarding of any prizes.{" "}
                <br />
                You may not use a username that promotes a commercial venture or
                a username that VAULT in its sole discretion deems offensive.
                Other portions of the Service may require registration for
                access (the “Restricted Areas”). VAULT may require you to change
                your username or may unilaterally change your username.
                <br />
                VAULT cannot and will not be liable for any loss or damage
                arising from your failure to comply with this Section.
                <br />
              </li>
              <li>
                Disqualification and Cancellation. <br />
                VAULT, in its sole discretion, may disqualify you from a contest
                or the Service, refuse to award consideration or prizes and
                require the return of any consideration or prizes, or suspend,
                limit, or terminate your account if you engage in conduct VAULT
                deems, in its sole discretion, to be improper, unfair,
                fraudulent or otherwise adverse to the operation of the Service
                or in any way detrimental to other users. Improper conduct
                includes, but is not limited to: <br />
                • gaining an unfair advantage in contests by using information
                you obtain through your employment or work with a music label,
                artist, or streaming service;
                <br />
                • falsifying personal information, including payment
                information, required to use the Service or claim consideration
                or prizes; <br />
                • accumulating consideration or prizes through unauthorized
                methods such as unauthorized scripts or other automated means;
                <br />
                • tampering with the administration of the Service or trying to
                in any way tamper with the computer programs associated with the
                Service; <br />
                • obtaining other users’ information and spamming other users;
                <br />
                • abusing the Service in any way; <br />
                • or otherwise violating these Terms or any other agreement
                between you and another user or you and VAULT regarding your use
                of the Service or entry into a contest. <br />
                If for any reason the Service are not running as originally
                planned (e.g., if the Service become corrupted or do not allow
                the proper usage and processing of contests in accordance with
                the rules, or if infection by a computer virus, bugs, tampering,
                unauthorized intervention, actions by entrants, fraud, technical
                failures, or any other causes of any kind, in the sole opinion
                of VAULT corrupts or affects the administration, security,
                fairness, integrity or proper conduct of the Service), VAULT
                reserves the right, in its sole discretion, to cancel,
                terminate, extend, modify, or suspend the contest or Services,
                and/or select the winner(s) of a contest based on its
                then-current status. In addition, VAULT may, in its sole
                discretion, disqualify any individual implicated in or relating
                to the cause.
                <br />
                VAULT reserves the right to cancel, terminate, modify, or
                suspend contests, in our sole discretion, without any
                restrictions, in which case notification may be posted through
                the Service.
                <br />
                The failure of VAULT to comply with any provision of these Terms
                due to an act of God, hurricane, war, fire, riot, earthquake,
                terrorism, act of public enemies, actions of governmental
                authorities outside of the control of VAULT (excepting
                compliance with applicable codes and regulations) or other force
                majeure event will not be considered a breach of these Terms.
                <br />
              </li>
              <li>
                Withdrawals and Taxes
                <br />
                By entering contests or withdrawing funds, you agree to provide
                us with information we request, which may include a valid
                mailing address, date of birth, government identifiers, and
                social security number, and any other information we may require
                in order to run appropriate identity checks and comply with
                applicable rules and regulations. If necessary, you may be
                required to provide appropriate documentation that allows us to
                verify you. <br />
                You, not VAULT, are responsible for filing and paying applicable
                state and federal taxes, duties, levies and/or fees on any
                winnings. VAULT does not provide tax advice, nor should any
                statements in this agreement or on the Service be construed as
                tax advice.
                <br />
              </li>
              <li>
                Publicity
                <br />
                Entrants agree that VAULT may announce any winner’s username on
                any of its websites or any other location at any time in
                connection with the marketing and promotion of VAULT or other
                contests or games operated by VAULT. You agree that
                participation in and (where applicable) the winning of a prize
                in connection with a contest constitute complete compensation
                for your obligations under this paragraph, and you agree not to
                seek to charge a fee or impose other conditions on the
                fulfillment of these obligations. The rules specific to certain
                contests may contain additional publicity obligations or may
                require a written signature on a separate publicity waiver.
              </li>
              <li>
                Contests
                <br />
                Each contest is governed by the specific contest rules, scoring
                rules, controls and guidelines for that contest. Such rules,
                scoring rules, controls and guidelines form part of these Terms
                and you agree that you shall comply with them in respect of each
                individual contest which you choose to enter.
                <br />
                Game of Skill.
                <br /> VAULT’s Fantasy Record Label game is a game of skill.
                Winners are determined by the criteria stated in each contest’s
                rules. For each contest, winners are determined by the entrants
                exhibiting their skill in the relevant fantasy music game.
                <br />
                Entry and Entry Fees.
                <br /> In order to enter into a contest, a user must register
                for VAULT’s Fantasy Record Label game, follow the instructions,
                and make roster selections and picks according to the
                instructions in the VAULT Fantasy Record Label game. <br />
                In the event that the awarding of any prizes to winners of the
                contest is challenged by any legal authority, VAULT reserves the
                right in its sole discretion to determine whether or not to
                award or adjust such prizes. In all disputes arising out of the
                determination of the winner of VAULT contests, VAULT is the sole
                judge and its actions are final and binding.
                <br />
                The Services are in no way sponsored, endorsed or administered
                by, or in association with Spotify USA Inc. or its respective
                affiliates. Questions and comments regarding the Service and its
                contests should be directed to VAULT and not to the third
                parties such as Spotify.
                <br />
                Data.
                <br />
                 In the event that Spotify does not update monthly listener
                numbers for any or all artists prior to settlement then VAULT
                will settle the competition using the most recent available data
                point.
                <br />
              </li>
              <li>
                Access to the Service
                <br />
                You must provide, at your own expense, the equipment, software,
                subscriptions, Internet connections or devices and/or service
                plans as may be required to access and/or use the Service. VAULT
                does not guarantee that the Service or all portion(s) thereof
                can be accessed on all devices. VAULT does not guarantee that
                the Service are available in all geographic locations. You
                acknowledge that when you use the Service, your Internet
                provider may charge you fees for access, data, and/or other
                contents, products, or services. Check with your applicable
                provider(s) to see if there are any such fees that apply to you.
                <br />
              </li>
              <li>
                Spotify <br />
                The terms in this paragraph relate only to a User’s access to
                the Service with a Spotify login.
                <br />
                Specifically, VAULT:
                <br />
                (a) expressly disclaims all implied warranties with respect to
                the Spotify Platform, Spotify Service, and Spotify Content,
                including the implied warranties of merchantability, fitness for
                a particular purpose and non-infringement;
                <br />
                (b) prohibits modifying or creating derivative works based on
                the Spotify Platform, Spotify Service or Spotify Content;
                <br />
                (c) prohibits Users from decompiling, reverse-engineering,
                disassembling, and otherwise reducing the Spotify Platform,
                Spotify Service, and Spotify Content to source code or other
                human-perceivable form, to the full extent allowed by law; and
                <br />
                (d) states that Spotify is a third-party beneficiary of the App’
                end user license agreement and privacy policy and is entitled to
                directly enforce the App’ end user license agreement.
                <br />
              </li>
              <li>
                Code of Conduct
                <br />
                You agree not to do or attempt to do any of the following:
                <br />
                • Participate in a contest on behalf of multiple users
                (including through multi-accounting) or otherwise collaborate or
                collude with others to participate in any contest or to achieve
                competitive advantage;
                <br />
                • Use cheats, exploits, hacks, bots, mods or third-party
                software designed to gain an advantage, perceived or actual,
                over other users of the App, or modify or interfere with the
                App; <br />
                • Violate contest rules, these Terms, any Other Governing
                Agreement, or any applicable law or regulation;
                <br />
                • Tamper with the administration of a contest or tamper with the
                computer programs or any security measure associated with a
                contest;
                <br />
                • Access, tamper with, or use non-public areas of the App,
                VAULT’s computer systems, or the technical delivery systems of
                VAULT’s providers; <br />
                • Probe, scan or test the vulnerability of any VAULT system or
                network or breach, compromise, or circumvent any security or
                authentication measures; <br />
                • Interfere with, disrupt, interrupt, negatively affect or
                inhibit other users from enjoying the App, or take actions that
                could damage, interrupt, disable, overburden or impair the
                functioning of the Service in any manner;
                <br />• Decipher, decompile, disassemble or reverse engineer or
                otherwise derive any source code or underlying ideas or
                algorithms of any part of the Service (including without
                limitation any application or software used to provide the App);{" "}
                <br />
                • Create a false identity or a user account for anyone other
                than yourself, impersonate or misrepresent your affiliation with
                any person or entity or falsify personal information or location
                information required to enter a contest or claim prizes;
                <br />
                • Abuse the Service in any way; or
                <br />
                • Encourage or enable any other individual or User to do any of
                the foregoing.
                <br />
                A violation of this Section 12 may result in the removal of your
                content from the Service and/or the suspension or termination of
                your account or right and ability to use the Service. You
                acknowledge and agree that VAULT may in its sole discretion
                remove any User Content, block access to the Service or the
                content therein, and suspend or terminate any account at any
                time for violation of these Terms. To report abuse of the Terms,
                please contact us at support@vault.fan.
                <br />
              </li>
              <li>
                Further Restrictions
                <br />
                Your right to use the Service is limited to the license grant
                above, and you may not otherwise copy, display, seek to disable,
                distribute, perform, publish, modify, transfer, create works
                from, or use the Service or any component of it, except as
                expressly authorized by VAULT. Unless expressly authorized in
                writing by VAULT, you are prohibited from making the Service
                (and/or a copy of the App) available on or over a network where
                it could be used and/or downloaded by multiple users. You may
                not remove or alter any of VAULT’s trademarks and/or logos, any
                legal notices included in the Service and/or any related assets.
                Your right to use the Service is also predicated on your
                compliance with any applicable terms or agreements you have with
                third parties when using the Service.
                <br />
              </li>
              <li>
                Warranty Disclaimers
                <br />
                You expressly understand and agree that your use of the Service
                is at your sole risk. The Services (including the related
                websites, apps, and coNtent) are provided on an "AS IS" and "as
                available" basis, without warranties of any kind, either express
                or implied, including, without limitation, implied warranties of
                merchantability, fitness for a particular purpose or
                non-infringement. You acknowledge that VAULT has no control
                over, and no duty to take any action regarding: which users gain
                access to or use the SERVICE; what effects the content may have
                on you; how you may interpret or use the content; or what
                actions you may take as a result of having been exposed to the
                content. You release VAULT from all liability for you having
                acquired or not acquired content through the Service. The
                Services may contain, or direct you to other websites containing
                information that some people may find offensive or
                inappropriate. VAULT makes no representations concerning any
                content contained in or accessed through the SERVICE, and VAULT
                will not be responsible or liable for the accuracy, copyright
                compliance, legality or decency of material contained in or
                accessed through the Service. <br />
              </li>
              <li>
                Termination
                <br />
                VAULT reserves the right at any time to modify, suspend,
                discontinue, or terminate, temporarily or permanently, the
                Service or associated services (or any part thereof), with or
                without notice. You agree that VAULT shall not be liable to you
                or any third party for any modification, suspension or
                discontinuance of the Service or associated services. You will,
                however, have the opportunity to withdraw all funds in your
                account at the time of termination, unless VAULT, in its sole
                discretion, determines that those funds are disputed or
                otherwise were not earned in compliance with these Terms or the
                law. If you wish to terminate your account, you may simply
                discontinue using the Service or contact us at support@vault.fan
                via an email expressly stating that you wish to terminate your
                account.
                <br />
              </li>
              <li>
                Notice to California Users
                <br />
                Under California Civil Code Section 1789.3, users located in
                California are entitled to the following consumer rights notice:
                If a user has a question or complaint regarding the Service,
                 please send an email to support@vault.fan.  Users may also
                contact us by writing to 631 Orienta Ave, Mamaroneck, New York
                10543. California residents may reach the Complaint Assistance
                Unit of the Division of Consumer Services of the California
                Department of Consumer Affairs by mail at 1625 North Market
                Blvd., Suite N 112, Sacramento, CA 95834, or by telephone at
                (916) 445-1254 or (800) 952-5210.
                <br />
              </li>
              <li>
                Miscellaneous <br />
                Severability and Survival. If any provision of these terms is
                found invalid by a court of competent jurisdiction, you agree
                that the court should try to give effect to the parties’
                intentions as reflected in the provision and that other
                provisions of the Terms will remain in full effect.
                <br />
                Limitation of Liability and Disclaimer of Warranties are
                Material Terms of these Terms. You agree that the provisions in
                incorporated into these Terms that limit liability and disclaim
                warranties are essential terms of these Terms.
                <br />
                Entire Agreement. These Terms (including any document
                incorporated by reference into them) are the whole agreement
                between VAULT and you concerning the Service. If you have any
                questions please email support@vault.fan.
                <br />
                No Waiver. The failure of VAULT to exercise or enforce any right
                or provision of the Terms shall not constitute a waiver of such
                right or provision.
                <br />
              </li>
              <li>
                Contacting Us
                <br />
                E-mail is an important communication channel for our users. By
                providing VAULT with your e-mail address, you authorize VAULT to
                use that e-mail address to deliver notices or disclosures
                related to the Service and as otherwise described in the VAULT
                <a href="/privacy-policy">Privacy Policy</a>. You may opt out of
                these communications at any time by using the contact
                information below. <br />
              </li>
              If you have any questions, concerns, requests or comments
              regarding these Terms, or if you wish to opt out of communications
              from VAULT, we invite you to contact us by email at
              support@vault.fan or write to us at 631 Orienta Ave, Mamaroneck,
              New York 10543
              <br />
            </ol>
          </Text>
        </TextBlockWithTitle>
      </PageLayout>
    </>
  );
};

export default TermsOfService;

export const Text = styled.p`
  font-size: 18px;
  ${xSmallScreen(css`
    font-size: 14px;
  `)}
`;
